import React, { useEffect, useState } from 'react';
import { Title, Text, Stack } from '@mantine/core';
import { useAuth } from '../../contexts/AuthContext';
import { getPastRegistrations } from '../../services/reportService';
import PastCompetitionCard from './PastCompetitionCard';

/**
 * PastCompetitionsSection
 *
 * Lists the user's registrations from seasons whose competition day has
 * passed (see isSeasonPast in config/seasons.js), one card each with the
 * variations performed and the judging-report button. Renders nothing while
 * loading or when there is no history, so first-year users see no empty box.
 */
const PastCompetitionsSection = () => {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!user?.id) { setLoaded(true); return undefined; }
    (async () => {
      try {
        const data = await getPastRegistrations(user.id, user.email);
        if (!cancelled) setRows(data);
      } catch (err) {
        console.error('PastCompetitionsSection load error:', err);
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => { cancelled = true; };
  }, [user?.id, user?.email]);

  if (!loaded || rows.length === 0) return null;

  return (
    <div>
      <Title order={3} size="h4" mb="xs" style={{ color: 'var(--charcoal)', textAlign: 'left' }}>
        Past Competitions
      </Title>
      <Text size="sm" c="dimmed" mb="md" style={{ textAlign: 'left' }}>
        Your record from previous seasons. Judging reports appear here once results are released.
      </Text>
      <Stack gap="md">
        {rows.map((r) => <PastCompetitionCard key={r.id} registration={r} />)}
      </Stack>
    </div>
  );
};

export default PastCompetitionsSection;
